var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGlassWater(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 54,
    viewBox: "0 0 42 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.8505 53H6.7944L1 1H40.6449L34.8505 53Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1494 26.8541C18.5327 26.8541 19.6541 25.7327 19.6541 24.3494C19.6541 22.9661 18.5327 21.8447 17.1494 21.8447C15.7661 21.8447 14.6448 22.9661 14.6448 24.3494C14.6448 25.7327 15.7661 26.8541 17.1494 26.8541Z",
    fill: "#EB731A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.99 36.0318C29.3733 36.0318 30.4947 34.9104 30.4947 33.5271C30.4947 32.1438 29.3733 31.0225 27.99 31.0225C26.6067 31.0225 25.4854 32.1438 25.4854 33.5271C25.4854 34.9104 26.6067 36.0318 27.99 36.0318Z",
    fill: "#EB731A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9908 43.523C19.374 43.523 20.4954 42.4016 20.4954 41.0183C20.4954 39.6351 19.374 38.5137 17.9908 38.5137C16.6075 38.5137 15.4861 39.6351 15.4861 41.0183C15.4861 42.4016 16.6075 43.523 17.9908 43.523Z",
    fill: "#EB731A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.48633 15.04H38.1592",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlassWater);
export default __webpack_public_path__ + "static/media/glass-water.ca816d0cee8ff619598ab439873a9ee6.svg";
export { ForwardRef as ReactComponent };